import { createTheme } from '@mui/material/styles';

// SquareShift Brand Colors
const colors = {
  deepGreen: '#0D5630',
  sageGreen: '#426653',
  royalGold: '#D4AF37',
  bronzeGold: '#B8860B',
  pureGold: '#F3CD29',
  black: '#000000',
  mediumGrey: '#595959',
  darkGrey: '#181818',
  white: '#FFFFFF',
  warmBeige: '#C5B9AB',
  deepBrown: '#57473A',
  mediumTaupe: '#A59788',
  lightCream: '#E6DFD4',
  sageBrown: '#83735F',
  bgLight: '#F7FAFC',
  bgWhite: '#FFFFFF',
  border: '#D1D5DB',
  textSecondary: '#4A5568',
  textMuted: '#718096',
};

const theme = createTheme({
  palette: {
    primary: {
      main: colors.deepGreen,
      light: colors.sageGreen,
      dark: '#083D21', // Darker shade of deep green
      contrastText: colors.white,
    },
    secondary: {
      main: colors.royalGold,
      light: colors.pureGold,
      dark: colors.bronzeGold,
      contrastText: colors.white,
    },
    background: {
      default: colors.bgLight,
      paper: colors.bgWhite,
    },
    text: {
      primary: colors.black,
      secondary: colors.mediumGrey,
    },
    custom: {
      ...colors,
    },
  },
  typography: {
    fontFamily: '"Roboto Condensed", "Helvetica", "Arial", sans-serif',
    h1: {
      fontFamily: '"Fjalla One", sans-serif',
      fontWeight: 400,
      color: colors.deepGreen,
    },
    h2: {
      fontFamily: '"Fjalla One", sans-serif',
      fontWeight: 400,
      color: colors.black,
    },
    h3: {
      fontFamily: '"Fjalla One", sans-serif',
      fontWeight: 400,
      color: colors.mediumGrey,
    },
    h4: {
      fontFamily: '"Roboto Condensed", sans-serif',
      fontWeight: 700,
      color: colors.darkGrey,
    },
    h5: {
      fontFamily: '"Roboto Condensed", sans-serif',
      fontWeight: 700,
    },
    h6: {
      fontFamily: '"Roboto Condensed", sans-serif',
      fontWeight: 700,
    },
    button: {
      fontFamily: '"Roboto Condensed", sans-serif',
      fontWeight: 700,
      textTransform: 'none',
    },
    body1: {
      fontFamily: '"Roboto Condensed", sans-serif',
    },
    body2: {
      fontFamily: '"Roboto Condensed", sans-serif',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: '12px 24px',
          boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
          transition: 'all 0.2s ease',
          '&:hover': {
            transform: 'translateY(-1px)',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          },
        },
        containedPrimary: {
          backgroundColor: colors.royalGold,
          color: colors.white,
          '&:hover': {
            backgroundColor: colors.bronzeGold,
          },
        },
        outlinedPrimary: {
          borderColor: colors.bronzeGold,
          color: colors.deepGreen,
          borderWidth: 2,
          '&:hover': {
            backgroundColor: colors.bgLight,
            borderColor: colors.bronzeGold,
            borderWidth: 2,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
          border: `1px solid ${colors.border}`,
          '&:hover': {
            boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
            borderColor: colors.sageGreen,
            transform: 'translateY(-4px)',
          },
          transition: 'all 0.3s ease',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: colors.white,
          color: colors.black,
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        },
      },
    },
  },
});

export default theme;
